"use client"
import { useSelector } from "react-redux";
import { Box, Icon, Text } from "@quintoandar-tokko/jopijs";
import useCalendarInputs from "../hooks/useCalendarInputs";
import CalendarFormError from "../calendarFormError/CalendarFormError";
import Trans from "@/components/shared/Trans";
import translations from './calendarForm.trans.json'
import style from "./calendarForm.module.scss"

export default function CalendarForm() {
  const calendar = useSelector(state => state.CalendarSlice)
  const { listOfInputs, handlers } = useCalendarInputs()
  const { handleChange, handleFocus, handleBlur } = handlers

  const renderInputs = (inputs) => (
    inputs.map((input) => {
      if (input.group) {
        const nonGroupChildrenCount = input.data.filter(el => !el.group).length
        const isOdd = nonGroupChildrenCount % 2 !== 0

        return (
          <Box
            key={`group-${input.data.map(d => d.id).join('-')}`}
            className={style.calendarFormInputGroup}
            data-odd={isOdd}
          >
            {renderInputs(input.data)}
          </Box>
        );
      }

      const isRestricted = Boolean(calendar.form[input.id]?.restrictedValue)
      const isRequired = calendar.form[input.id]?.required
      const value = isRestricted ? calendar.form[input.id]?.restrictedValue : calendar.form[input.id]?.value
      const hasError = calendar.form[input.id]?.error
      const isFocused = calendar.form[input.id]?.focused
      const showError = hasError && !isFocused
      const errorText = Trans(translations, calendar.form[input.id]?.errorKey)
  
      return (
        <Box
          key={input.id}
          as="label"
          className={`${input.containerClasses} ${isRestricted ? style.restrictedFormField : ''}`}
        >
          <Text className={style.calendarFormLabel}>
            {isRequired
              ? input.labelText
              : `${input.labelText} (${Trans(translations, 'Optional')})`
            }
          </Text>
          <Box
            className={input.inputWrapperClasses}
            data-error={showError}
            data-disabled={isRestricted}
          >
            <Box
              as={input.type}
              className={input.classes}
              inputMode={input.mode}
              placeholder={input.placeholder}
              value={value}
              onChange={(event) => handleChange(event, input.maxLength)}
              onFocus={handleFocus}
              onBlur={handleBlur}
              data-field={input.id}
              disabled={isRestricted}
            />
            {showError && (
              <Box className={style.iconErrorWrapper}>
                <Icon icon="icon-error" fontSize="16px" color="var(--colors-text-icon-critical-onground)" />
              </Box>
            )}
          </Box>
          {!showError && !isRestricted && input.footerText && (
            <Text className={style.calendarFormInputFooterMessage}>{input.footerText}</Text>
          )}
          {showError && (
            <CalendarFormError>{errorText}</CalendarFormError>
          )}
        </Box>
      );
    })
  );

  return (
    <Box as="section" className={style.calendarFormContainer}>
      <Text className={style.calendarFormTitle}>
        {Trans(translations, 'ContactInformation')}
      </Text>

      <Box as="form" className={style.calendarForm}>
        {renderInputs(listOfInputs)}
      </Box>
    </Box>
  );
}
